import { getAppConfigValue, getAuthHTTPClient } from '@elliemae/pui-app-sdk';
import { getRequestHeaders } from '../api/eppsService';

export class AuthenticationService {
  client: ReturnType<typeof getAuthHTTPClient>;

  static refreshToken: any;

  get baseUrl() {
    return getAppConfigValue<string>('serviceEndpoints.loanCatcherApi');
  }

  constructor() {
    this.client = getAuthHTTPClient();

    // Add a request interceptor to set default headers
    this.client.interceptors.request.use((config) => {
      for (const [key, val] of Object.entries(getRequestHeaders())) {
        config.headers[key] = val;
      }
      return config;
    });
  }

  async login(creds: { emailAddress: string; password: string }) {
    try {
      const response = await this.client.post(
        `${this.baseUrl}/users/authenticate`,
        creds,
      );
      return response;
    } catch (err: any) {
      if (err?.response && err?.response?.status === 403) {
        console.log('catching MFA error. Continuing');
        return err.response;
      }
      throw err;
    }
  }

  async loginWithMFACode(mfaResponseUuid: string, mfaCode: string) {
    try {
      const response = await this.client.post(
        `${this.baseUrl}/users/multi-factor/verify/${mfaResponseUuid}?SILENT_ERROR`,
        { code: mfaCode },
      );
      const token = response.data.item.sessionState.accessToken as string;
      const sessionState = response.data.item.sessionState;
      this.client.interceptors.request.use((config) => {
        for (const [key, val] of Object.entries(getRequestHeaders())) {
          config.headers[key] = val;
        }
        return config;
      });
      return [token, sessionState];
    } catch (error) {
      console.error('MFA Verification failed', error);
      throw error;
    }
  }

  async refreshToken() {
    try {
      const response = await this.client.post(
        `${this.baseUrl}/users/authenticate/refresh`,
        null,
        {
          headers: getRequestHeaders(),
        },
      );
      const token = response.data.item.sessionState.accessToken as string;
      const sessionState = response.data.item.sessionState;

      this.client.interceptors.request.use((config) => {
        for (const [key, val] of Object.entries(getRequestHeaders())) {
          config.headers[key] = val;
        }
        return config;
      });
      localStorage.setItem('sessionEnd', sessionState.softExpirationDate);
      return { token, sessionState };
    } catch (error) {
      console.error('Token refresh failed', error);
      throw error;
    }
  }
}
